// extracted by mini-css-extract-plugin
module.exports = {"active":"nav-bar-routes_active_1xFPv"};